import React, { useEffect, useState } from "react";
import { Box, Typography, Paper } from "@mui/material";
const IframeComponent = () => {
  const [iframeHeight, setIframeHeight] = useState("400px");

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin === "http://localhost:3000") {
        const { type, iframeHeight } = event.data || {};
        if (type === "setHeight" && iframeHeight) {
          setIframeHeight(`${iframeHeight}px`);
        }
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);
  return (
    <Box sx={{ p: 4, height: `${iframeHeight}` }}>
      <Typography variant="h5" align="center" gutterBottom>
        Embedded Content
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          height: `${iframeHeight}`,
        }}
      >
        <Paper elevation={3} sx={{ width: "80%", height: `${iframeHeight}` }}>
          <iframe
            src="http://localhost:3000/new-booking"
            title="Embedded Page"
            width="100%"
            height={iframeHeight}
            style={{ border: "none" }}
            scrolling="no"
          />
        </Paper>
      </Box>
    </Box>
  );
};
export default IframeComponent;
